<template>
	<Modal 
		:width="1600"
		:title="theTitle"
		@close="close"
	>

		<template v-slot:content>

			<Insights 
				:projectId="projectId" 
				:source="source" 
			/>

		</template>

	</Modal>
</template>

<script>
import Modal from './Modal.vue';
import Insights from './../../views/Insights.vue';
export default {
	name: "InsightsModal",
	components: { Insights, Modal },
	props: {
		projectId: {
			type: String
		},
		source: {
			type: String,
			default: "rankTracking"
		},
		title: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			top: 0,
		};
	},
	data() {
		return {
			closed: false,
		};
	},
	watch: {},
	computed: {
		theTitle () {
			return this.title || 'Insights';
		}
	},
	methods: {
		close() {
			this.$emit('close');
		},
	},
	created() {
		
	},
	beforeDestroy() {
		
	},
};
</script>
